import React, { useState, useMemo, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

import PracticeDetails from "components/provider-intake/practice-details/PracticeDetails";

import { AmplitudePageName, track } from "utils/amplitude";
import { useTimeOnPageContext } from "contexts/time-on-page";
import { useSubscription } from "contexts/subscription-context";
import ConsentCollection from "./ConsentCollection";
import TeamMembers from "./TeamMembers";

import styles from "./PracticeSetting.module.scss";

const PRACTICE_SETTING_OPTIONS = [
  { value: "practice-details", label: "Practice Details", isForAIPlan: false },
  // { value: "team-members", label: "Team Members", isForAIPlan: false },
  // {
  //   value: "consent-collection",
  //   label: "Consent Collection",
  //   isForAIPlan: true,
  // },
];

const AMPLITUDE_PAGE_NAME: AmplitudePageName = "pro-settings-practice-settings";

const PracticeSetting = () => {
  const { planType } = useSubscription();
  const { setPage } = useTimeOnPageContext();
  useEffect(() => {
    setPage(AMPLITUDE_PAGE_NAME);
  }, [setPage]);

  const navigate = useNavigate();

  const location = useLocation();
  const { activeTab } = useMemo(() => {
    const query = new URLSearchParams(location.search);
    return {
      activeTab: query.get("tab") || "",
    };
  }, [location.search]);

  const [tab, setTab] = useState(activeTab || "practice-details");

  return (
    <div className={styles["practice-setting"]}>
      <div className={styles["practice-setting__header"]}>
        <h4 className={"rg-32 deep-blue questrial mb-0"}>Practice Settings</h4>
        <Tabs
          activeKey={tab}
          onSelect={(k) => {
            setTab((s) => k || s);
            navigate(
              `/pro-dashboard/settings/practice-setting?tab=${k}`,
              { replace: true }
            );
          }}
          className={styles["practice-setting__tabs"]}
        >
          {PRACTICE_SETTING_OPTIONS.map((el, i) => {
            return el.isForAIPlan === true && planType !== "ai-only" ? null : (
              <Tab
                key={el.value}
                eventKey={el.value}
                title={el.label}
                tabClassName={styles["practice-setting__tab"]}
                onEnter={() =>
                  track(AMPLITUDE_PAGE_NAME, "practice-settings-tab", "click")
                }
              ></Tab>
            );
          })}
        </Tabs>
      </div>

      {tab === "practice-details" && (
        <PracticeDetails amplitudePageName={AMPLITUDE_PAGE_NAME} />
      )}
      {tab === "consent-collection" && (
        <ConsentCollection AMPLITUDE_PAGE_NAME={AMPLITUDE_PAGE_NAME} />
      )}

      {tab === "team-members" && <TeamMembers />}
    </div>
  );
};

export default PracticeSetting;
